// import core & vendor packages below
import { Helmet, HelmetData } from 'react-helmet-async';
import React from 'react';

// main component
const ReactHelmet = (props) => {
  const { title } = props;
  const helmetData = new HelmetData({});

  return (
    <Helmet helmetData={helmetData}>
      <meta charSet='utf-8' />
      <title>Short flix - {title}</title>
    </Helmet>
  );
};

export default ReactHelmet;
